import React, { useEffect, useState } from 'react';
import { NextPageContext } from 'next';

import { Breadcrumbs, CourseInformation, HeroCourse } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import { getHeadings, renderCoursePageContent } from '../../../lib/ContentRenderer';
import ErrorPage from '../../_error';
import NotFoundPage from '../../404';

import query from './index.graphql';

import { trackViewItem } from "../../../lib/GA";

interface Props {
  slug: string;
}

const CoursePage = ({ slug }: Props) => {
  const [{ data, error }] = useSiteQuery<CourseQuery>({ query, variables: { slug } });
  const [loaded, setLoaded] = useState(false);

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;
  const headings = getHeadings(entry?.pageContent, []);

  if (entry) {
    const title = entry.title!;
    const uri = entry.uri!;

    const breadcrumbs: BreadcrumbItem[] = [
      { title: 'Courses', uri: '/courses' },
      { title, uri },
    ];

    if (data?.globalSet) {
      const globalSet = data?.globalSet;
      const bookeoEnabled = globalSet?.enableBookeoIntegration!;
      const courseId = entry.bookeoCategoryIdentifier!;

      if (bookeoEnabled && courseId) {
        useEffect(() => {
          if (!loaded) {
            trackViewItem(window, courseId, title);
            setLoaded(true);
          }
        }, [loaded]);
      }
    }

    return (
      <div>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <HeroCourse headings={headings}>
          <div className="sectionHeading">{entry.courseID}</div>
          <h1 className="heroH1 fullWidth" data-test-id="customTitle">
            {title}
          </h1>
        </HeroCourse>
        <div className="section">
          <div className="container">
            <div className="row">
              <div className="mobileOnly col-12 pb-2">
                <CourseInformation course={entry} />
              </div>
              <div className="coursePage col-12 col-lg-7 pl-0 pr-0">
                {entry.pageContent?.map((row) => renderCoursePageContent(row!))}
              </div>
              <div className="desktopOnly col-12 col-lg-5 pr-1 pl-xl-0 pr-xl-0">
                <CourseInformation sticky course={entry} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <NotFoundPage />;
};

CoursePage.getInitialProps = ({ req }: NextPageContext) => ({
  slug: req?.url?.substring(req?.url?.lastIndexOf('/') + 1).replace(/\?.*$/, ''),
});

export default CoursePage;
